import { FormControl, InputLabel, TextField } from "@mui/material";
import { FormHelperTextError } from "../errors";
import { ChipTextField } from "./chip-textfield";

function AppTextField({ inputProps, errorProps, labelProps, rootProps }: any) {
  const handleOnFocus = (e) => {
    inputProps?.onFocus && inputProps?.onFocus(e);
  };

  const handleOnBlur = (e) => {
    inputProps?.onBlur && inputProps?.onBlur(e);
  };

  return (
    <FormControl
      fullWidth
      error={errorProps?.error ? true : false}
      margin="none"
      variant="standard"
      {...rootProps}
    >
      <InputLabel
        required={errorProps?.required !== false}
        htmlFor={inputProps?.id}
        shrink
      >
        {labelProps?.label}
      </InputLabel>
      <TextField
        value={inputProps?.value || ""}
        name={inputProps?.name}
        aria-describedby={`component-error-text-${inputProps?.id}`}
        autoComplete="off"
        variant="outlined"
        size="small"
        fullWidth
        onFocus={handleOnFocus}
        onBlur={handleOnBlur}
        {...inputProps}
        sx={{ bgcolor: "white", ...inputProps?.sx }}
      />
      <FormHelperTextError
        id={`component-error-text-${inputProps?.id}`}
        error={errorProps?.error}
        helperText={errorProps?.helperText}
      />
    </FormControl>
  );
}

export { AppTextField, ChipTextField };
export { FormTextField } from "./form-textfield";
